<template>
  <div class="corpo-pagina">

    <!-- TITOLO -->
    <div class="row">
      <div class="col s12">
        <h4 class="page-title">{{ translation('btn.new.room') }} </h4>
      </div>
    </div>

    <div class="divider mb-4"></div>

    <form @submit.prevent="createRoom">

      <!-- NOME STANZA — OPZIONE COLORE / TOGGLE + COLOR PICKER -->
      <div class="row">
        <!-- NOME STANZA -->
        <div class="col s12 m5 l5">
          <div class="input-field w-100">
            <i class="material-icons prefix">meeting_room</i>
            <input id="name"
                   type="text"
                   v-model.trim="formData.name"
                   class="validate required"
                   autocomplete="off"
                   required>
            <label for="name">{{ translation('header.table.room.name') }}</label>
          </div>
        </div>

        <div class="col s12 m2 l2"></div>

        <!-- OPZIONE BLOCCO: Toggle Switch + Color Picker sulla stessa riga -->
        <div class="col s12 m5 l5">
          <div class="option-block z-depth-1">
            <div class="option-icon red-text">
              <i class="material-icons">palette</i>
            </div>
            <div class="option-text">
              {{ translation('header.table.room.color') }}
            </div>
            <div class="option-radios">
              <div class="switch">
                <label>
                  <input type="checkbox" v-model="useColor" />
                  <span class="lever"></span>
                  {{ translation('btn.attiva.colorpicker') }}
                </label>
              </div>
            </div>
            <!-- Color picker integrato sulla stessa riga -->
            <div class="ml-3" v-if="useColor" style="width: 50px; flex-shrink: 0;">
              <input id="color" type="color" v-model="formData.color" class="color-input" title="Colore Stanza">
            </div>
          </div>
        </div>
      </div>

      <!-- DESCRIZIONE -->
      <div class="row">
        <div class="col s12">
          <div class="input-field w-100">
            <i class="material-icons prefix">description</i>
            <textarea id="description" class="materialize-textarea" v-model="formData.description"></textarea>
            <label for="description">{{ translation('header.table.room.description') }}</label>
          </div>
        </div>
      </div>

      <!-- SEZIONE IMMAGINE E ANTEPRIMA (Visibile solo se useColor è false tramite v-show) -->
      <div class="row" v-show="!useColor">
        <!-- IMMAGINE SELECT -->
        <div class="col s12 m5 l5">
          <div class="input-field w-100">
            <i class="material-icons prefix">image</i>
            <select v-model="formData.img" id="img_select_reactive" class="icons">
              <option value="" disabled selected>{{ translation('select.img.background.room') }}</option>
              <option
                v-for="imgOption in imageOptions"
                :key="imgOption.value"
                :value="imgOption.value"
                :data-icon="imgOption.path"
                class="room-image-option circle"
              >
                {{ imgOption.text }}
              </option>
            </select>
            <label>{{ translation('img.room') }}</label>
          </div>
        </div>

        <div class="col s12 m2 l2"></div>

        <!-- ANTEPRIMA IMMAGINE -->
        <div class="col s12 m5 l5">
          <div class="input-field-preview">
            <label class="active mb-1">Anteprima</label>
            <div v-if="formData.img && selectedImagePath" class="image-preview-container z-depth-1">
              <img :src="selectedImagePath" alt="Anteprima Stanza" class="responsive-img room-preview-img" />
            </div>
            <div v-else class="image-preview-container no-image z-depth-1">
              <i class="material-icons grey-text text-lighten-2">image</i>
              <span class="grey-text font-small">{{ translation('no.img.room') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- SAVE BUTTON (ROSSO) -->
      <div class="row mt-4">
        <div class="col s12">
          <button id="saveroom"
                  class="btn-large new-event-btn"
                  type="submit"
                  :disabled="loadingStore.getters.isLoading">
            <i class="material-icons left">save</i>
            {{ translation('btn.save') }}
          </button>
          <button class="btn-large my-cancel-btn"
                  type="button"
                  @click="$router.push('/table-manager')">
            {{ translation('btn.annulla') }}
          </button>
        </div>
      </div>

      <!-- FEEDBACK VISIVO -->
      <div class="row mt-3">
        <div class="col s12">
          <p v-if="loadingStore.getters.isLoading" class="blue-text">{{ translation('progress.save') }}</p>
          <p v-if="successMessage" class="green-text text-darken-2"><strong>{{ successMessage }}</strong></p>
          <p v-if="errorMessage" class="red-text text-darken-2"><strong>{{ errorMessage }}</strong></p>
        </div>
      </div>

    </form>

  </div>
</template>

<script>
import loadingStore from '@/store/loading'
import konovaschema from '@/store/konovaschema.js'
import useAuthStore from '@/store/authStore.js'
import apiService from '@/services/apiService.js'
import eventSetting from '@/store/eventSettings.js'
import M from 'materialize-css'
import translationStore from '@/store/translations'

const KONVA_SCHEMA_BASE = {
  attrs: { width: 800, height: 600 },
  className: 'Stage',
  children: [
    {
      attrs: {},
      className: 'Layer',
      children: [
        { attrs: { width: 800, height: 600, stroke: 'black', id: 'stage-border' }, className: 'Rect' }
      ]
    },
    {
      attrs: { name: 'TableLayer' },
      className: 'Layer',
      children: [
        { attrs: { borderStroke: 'blue', anchorFill: 'blue', anchorStroke: 'blue', enabledAnchors: [] }, className: 'Transformer' }
      ]
    },
    { attrs: { name: 'FigureLayer' }, className: 'Layer', children: [] }
  ]
}

export default {
  name: 'RoomCreateView',
  data () {
    return {
      loadingStore,
      useColor: false,
      formData: {
        name: '',
        description: '',

        color: '#ffffff',
        img: '',
        jsonable: {}
      },

      imageOptions: [
        { value: 'modern', path: `${process.env.VUE_APP_URL_DOMAIN}/img/table/modern.png`, text: 'Modern' },
        { value: 'liberty', path: `${process.env.VUE_APP_URL_DOMAIN}/img/table/liberty.png`, text: 'Liberty' },
        { value: 'principesco', path: `${process.env.VUE_APP_URL_DOMAIN}/img/table/principesco.png`, text: 'Princely' },
        { value: 'elegante', path: `${process.env.VUE_APP_URL_DOMAIN}/img/table/elegante.png`, text: 'Elegant' },
        { value: 'natale', path: `${process.env.VUE_APP_URL_DOMAIN}/img/table/natale.png`, text: 'Christmas' }
      ],
      successMessage: null,
      errorMessage: null,
      translationStore: translationStore
    }
  },
  computed: {
    isAuth () {
      return useAuthStore.getters.isAuthenticated
    },
    fullEventData () {
      return eventSetting.getters.eventModel || {}
    },
    uidEvent () {
      return this.fullEventData.uid || null
    },
    selectedImagePath () {
      const selectedOption = this.imageOptions.find(opt => opt.value === this.formData.img)
      return selectedOption ? selectedOption.path : ''
    },
    translation () {
      return this.translationStore.getters.traduzione
    }
  },
  methods: {
    initializeMaterializeSelect () {
      this.$nextTick(() => {
        const selectElem = document.getElementById('img_select_reactive')
        if (selectElem && M) {
          const instance = M.FormSelect.getInstance(selectElem)
          if (instance) {
            instance.destroy()
          }
          M.FormSelect.init(selectElem)
        }
      })
    },

    async createRoom () {
      this.successMessage = null
      this.errorMessage = null

      const uid = this.uidEvent
      if (!uid) {
        this.errorMessage = this.translation('error.room.001')
        return
      }

      this.loadingStore.commit('setLoading', true)

      const tableIdentifier = `table-${this.formData.name.toLowerCase().replace(/\s/g, '-')}`
      const jsonablePayload = {
        table: tableIdentifier,
        konva_schema: KONVA_SCHEMA_BASE
      }

      const payload = {
        name: this.formData.name,
        description: this.formData.description,
        event_uid: uid,
        jsonable: jsonablePayload
      }

      if (this.useColor) {
        if (this.formData.color && this.formData.color !== '#ffffff') {
          payload.color = this.formData.color
          payload.img = null
        }
      } else {
        const selectedImgOption = this.imageOptions.find(opt => opt.value === this.formData.img)
        if (selectedImgOption) {
          payload.img = selectedImgOption.value
          payload.color = null
        } else {
          this.errorMessage = this.translation('error.room.002')
          this.loadingStore.commit('setLoading', false)
          return
        }
      }

      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
        this.loadingStore.commit('setLoading', false)
        return
      }

      const url = `${process.env.VUE_APP_URL_EVENTS}/table/create-room`

      try {
        const json = await apiService.sendRequestWithBearer('POST', url, token, payload)
        this.successMessage = this.translation('creat.room.success')
        await konovaschema.commit('setRoomData', json)
        const roomUid = konovaschema.getters.getRoomId
        this.$router.push('/table-manager/' + roomUid)
      } catch (error) {
        // console.error('Errore durante la creazione della stanza:', error)
        this.errorMessage = this.translation('error.room.003')
      } finally {
        this.loadingStore.commit('setLoading', false)
      }
    }
  },
  mounted () {
    localStorage.removeItem('activeTableInfo')
    localStorage.removeItem('activeTableSchema')

    if (typeof M !== 'undefined') {
      M.updateTextFields()
    }
    this.initializeMaterializeSelect()
  },
  watch: {
    useColor (newVal) {
      if (newVal) {
        this.formData.img = ''
      } else {
        this.formData.color = '#ffffff'
      }
    }
  }
}
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}

.color-input {
  height: 38px !important;
  width: 50px;
  padding: 2px;
  border: 1px solid #ccc !important;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.ml-3 {
  margin-left: 1rem !important;
}

.option-block {
  padding: 12px 16px;
  border-radius: 6px;
  background: #fafafa;
  display: flex;
  align-items: center;
  border: 1px solid #eee;
  height: 52px;
  margin-top: 5px;
}

.option-icon {
  margin-right: 15px;
}

.option-icon i {
  font-size: 26px;
}

.option-text {
  flex-grow: 1;
  font-weight: 500;
  color: #333;
}

.option-radios {
  display: flex;
  align-items: center;
}

.font-small {
  font-size: 0.82rem;
}

.input-field-preview {
  margin-top: 5px;
}

.image-preview-container {
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background: #fafafa;
  overflow: hidden;
  padding: 4px;
}

.image-preview-container.no-image {
  flex-direction: row;
  gap: 8px;
}

.image-preview-container.no-image i {
  font-size: 20px !important;
}

.room-preview-img {
  max-height: 100%;
  width: auto;
  object-fit: contain;
}
</style>

<style>
/* Stili globali necessari per Materialize Select Dropdown con immagini */
.dropdown-content li.room-image-option {
  display: flex !important;
  align-items: center !important;
  min-height: 58px !important;
  padding-left: 10px !important;
  line-height: normal !important;
}

.dropdown-content li.room-image-option img {
  float: none !important;
  order: 1 !important;
  width: 48px !important;
  height: 48px !important;
  margin-right: 12px !important;
  margin-left: 0 !important;
}

.select-wrapper input.select-dropdown {
  height: 48px !important;
  line-height: 48px !important;
}

.select-wrapper input.select-dropdown.active + label,
.select-wrapper input.select-dropdown:focus + label {
  top: -14px !important;
}
</style>
